import { environment } from "../../../environments/environment";
import { ChartSelectionCard } from "../Interfaces/chart-selection-card";
import { AppConstants } from "./app-constants";

export class SpeedometerChartConstants {
  speedometerChartImgFolderPath: string = "../../../assets/Images/SpeedometerChart/";
  /*baseUrl: string = environment.baseUrl;*/
  speedometerChartModuleRoutePath = AppConstants.speedometerCategoryPathMap.chartModuleRoutePath + "/";
  chartDescriptions: any = this.getChartDescriptions();
  speedometerChartModuleComponentPath: string = AppConstants.speedometerCategoryPathMap.moduleFolderPath;

  //contains the details of all kinds of speedometer charts that is available in the tool
  speedometerDiagramChartTypes: ChartSelectionCard[] = [
    // {
    //   "imgUrl": this.speedometerChartImgFolderPath + "01speedometerchart.png",
    //   routePath: this.speedometerChartModuleRoutePath + "SpeedometerChart1",
    //   description: this.chartDescriptions.genericSpeedometerChartDescription,
    //   chartFolderPath: this.speedometerChartModuleComponentPath + "speedometer-chart1"
    // },
    // {
    //   "imgUrl": this.speedometerChartImgFolderPath + "02speedometerchart.png",
    //   routePath: this.speedometerChartModuleRoutePath + "SpeedometerChart2",
    //   description: this.chartDescriptions.genericSpeedometerChartDescription,
    //   chartFolderPath: this.speedometerChartModuleComponentPath + "speedometer-chart2"
    // }
  ]

  //Returns the descriptions that has to be displayed in customization section of each speedometer chart
  getChartDescriptions() {
    let chartDescriptions = {
      genericSpeedometerChartDescription: [
        "Speedometer chart: Data pointer background-colour can be solid single colour, \
          linear gradient colour (two variation colours).",
        "Height can be adjusted according to data values.",
        "In x axis labels images/text can be used."
      ]
    }

    return chartDescriptions;
  }
}
